import styled from "styled-components";
export const Styles = styled.div`
  .title {
    color: var(--dark-purple);
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 17px;
  }
  .title a {
    display: block;
    width: fit-content !important;
    border-bottom: none !important;
    font-size: 10px !important;
    padding: 0 !important;
  }
  .filter {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0;
  }
  .filter button {
    border-radius: 25px !important;
    width: 80px !important;
    margin: 10px 0 !important;
  }
  .notifications-container {
    max-height: 300px;
    overflow: scroll;
  }
  .title-two {
    margin-bottom: 10px;
  }

  .notifications-container .notification {
    display: -webkit-inline-box;
    gap: 5px;
    margin-bottom: 15px;
    width: 100%;
  }
  .notifications-container .notification .circle {
    width: 35px;
    height: 35px;
    background: var(--dark-purple);
    border-radius: 50%;
  }
  .notifications-container .notification .content {
    padding-top: 5px;
    color: var(--dark-purple);
    font-size: 12px;
    text-align: start;
    width: 75%;
  }
  .button.selected .btn-secondary {
    background: var(--dark-purple);
    color: #fff;
    border: 1px solid var(--dark-purple);
  }
  .button.selected .btn-secondary:hover {
    background: #fff;
    color: var(--dark-purple);
  }
`;
